import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { DatePipe } from '@angular/common';
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import { AppConfigService } from "./main/app-config.service";
import { HeaderComponent } from "./header/header.component";
import { DatatableComponent } from "./datatable/datatable.component";
import { SearchformComponent } from "./searchform/searchform.component";
import { HomepageComponent } from "./homepage/homepage.component";
import { LoaderComponent } from "./loader/loader.component";
import { ErrordialogComponent } from "./errordialog/errordialog.component";
import { FaqComponent } from "./faq/faq.component";
import { DemoComponent } from "./demo/demo.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatRadioModule } from "@angular/material/radio";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHeaderInterceptor } from './app-header.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    DatatableComponent,
    SearchformComponent,
    HomepageComponent,
    LoaderComponent,
    ErrordialogComponent,
    FaqComponent,
    DemoComponent
  ],
  entryComponents: [ErrordialogComponent],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    MatSnackBarModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatTableModule,
    MatToolbarModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    BrowserAnimationsModule,
    PdfViewerModule
  ],
  providers: [DatePipe, { provide: HTTP_INTERCEPTORS, useClass: AppHeaderInterceptor, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule { }

export function initConfig(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}
